import { useCallback } from 'react';

const SPEED_OPTIONS = [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];

export const usePlaybackController = (
  currentRate: number,
  onRateChange: (rate: number) => void,
) => {
  const cyclePlaybackRate = useCallback(() => {
    const currentIndex = SPEED_OPTIONS.indexOf(currentRate);
    const nextIndex = (currentIndex + 1) % SPEED_OPTIONS.length;
    const newRate = SPEED_OPTIONS[nextIndex];
    
    onRateChange(newRate);
  }, [currentRate, onRateChange]);

  return {
    cyclePlaybackRate,
    currentRate,
    SPEED_OPTIONS,
  };
};
